import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import InvokeFormHandler, {DataRetrievedHandler, PrepareDataFormSavingHandler, NextButtonClickHandler, PreviousButtonClickHandler, FieldContentsChangeHandler, InvokeFormHandlerUsingForm, IncludeDynamicListsInForm} from '../../../Utils/General/FormStateHandler';
import AddFilterMetaData from './Functions/AddFilterMetaData';
import SinglePagePanel from '../../Forms/SinglePagePanel/SinglePagePanel';
import PostEvent from '../../../Data/PostEvents';
import PopulateFieldsWithNewContents from '../../../Utils/PageStructure/PopulateFieldsWithNewContents';
import PopulateCraftedWithNewContents from '../../../Utils/PageStructure/PopulateCraftedWithNewContents';
import GetWithNoParams from '../../../Data/GetWithNoParams';
import {PostList} from '../../../Data/Post';
import TransformDatesInJson from '../../../Utils/Local/TransformDatesInJson';
import TranslateTag from '../../../Utils/Local/TranslateTag';
import AdjustPageToHandleMultiPageView from '../../../Utils/General/MultiPageHandler';
import { SetDynamicDefaultValues } from '../../../Utils/PageStructure/GetDefaultValuesFromPage';
import RequiredFieldCheck from '../../../Utils/General/RequiredFieldCheck';

const FormHandler = (props) => {

    const [dataEntryErrorStatus, updateDataEntryErrorStatus] = useState({visible: false, message: ''});
    const [dataEntryState, setDataEntryState] = useState();
    const [formOpen, setFormOpen] = useState(false);
    const [fullScreen, setFullScreen] = useState(false);
    const [displayModeSwitchable, setDisplayModeSwitchable] = useState(true);
    const [finishAction, setFinishAction] = useState("");
    const [refreshConfig, setRefreshConfig] = useState(false);
    const [saveEnabled, setSaveEnabled] = useState(true);

    useEffect(() => {
        const dataRetrievedSuccessfully = (data, extraInfo) => {
            if (extraInfo.form === "monitoringjsonviewer") {
                TransformDatesInJson(data);
            }
            const state = DataRetrievedHandler(data, extraInfo, props.forms, props.pages, props.lists);

            if (state.dynamicLists.length > 0) {
                PostList(state.dynamicLists, dynamicListsRetrieved, errorWhenRetrievingData,{...state, button: extraInfo.button, fieldChanges: [] }, props.startConfig.id);
            }

            setDataEntryState({...state, button: extraInfo.button, fieldChanges: [] });
            setFormOpen(true);
        }

        if (props.startConfig !== undefined && props.startConfig.button !== undefined) {
            setFinishAction(props.startConfig.button.OnFinish !== undefined ? props.startConfig.button.OnFinish : props.startConfig.button.onFinish);
            setRefreshConfig(props.startConfig.button.refreshConfig);
            if (props.startConfig.button.UIEvent === undefined) {
                const form = props.forms.filter(f => f.Title === props.startConfig.formName);
                InvokeFormHandlerUsingForm(form, props.startConfig.id, dataRetrievedSuccessfully, errorWhenRetrievingData,undefined,undefined,props.filters, props.startConfig.selectedRecord);
            } else {
                InvokeFormHandler(props.startConfig.button, props.startConfig.id, props.uievents, props.forms, dataRetrievedSuccessfully, errorWhenRetrievingData, undefined,  props.filters, props.startConfig.selectedRecord);
            }

            const action = props.uievents.filter(a => a.Name === props.startConfig.button.UIEvent);

            if (action.length > 0) {
                const form = props.forms.filter(f => f.Name === action[0].Action);

                // Display stuff
                let overlayOnly = false;
                let fullScreenOnly = false;
                let fullScreenDefault = false;
                let displaySettings = form[0].DisplaySettings;
                if (displaySettings !== undefined &&
                    displaySettings !== null &&
                    displaySettings !== "")
                {
                    displaySettings = displaySettings.toLowerCase();
                    overlayOnly = displaySettings === "overlayonly"; 
                    fullScreenOnly = displaySettings === "fullscreenonly";
                    fullScreenDefault = displaySettings ===  "fullscreendefault";
                }
    
                if (props.startConfig.showFullScreenButton === undefined || props.startConfig.showFullScreenButton === true) {
                    setDisplayModeSwitchable(!overlayOnly && !fullScreenOnly);
                } else {
                    setDisplayModeSwitchable(false);
                }

                const fullScreenPreference = props.preferences !== undefined && props.preferences.DataFullScreen === "Yes";
                const goFullScreen = fullScreenDefault || fullScreenOnly || fullScreenPreference;
                setFullScreen(goFullScreen);

                if (props.startConfig.containerVisibility !== undefined) {
                    props.startConfig.containerVisibility(!goFullScreen);
                }
                // End of display stuff
            }

        } else {
            resetForm();
        }
    }, [props.startConfig, props.forms, props.lists, props.pages, props.uievents]);

    const errorWhenRetrievingData = (response) => {
        const errorMessage = response.data !== undefined ? response.data : response;
        updateDataEntryErrorStatus({visible: true, message: errorMessage});
    }

    const nextButtonClickHandler = (page, fieldChangesToUse, sourceOfClick) => {
        dataEntryErrorCloseHandler();
        const state = NextButtonClickHandler(page, fieldChangesToUse, sourceOfClick, dataEntryState, props.lists);
  
        if (state.error !== "") {
            updateDataEntryErrorStatus({visible: true, message: state.error + TranslateTag("@ValMes@",props.language)});
        } else {
            setDataEntryState(state);
        }
    }
  
    const previousButtonClickHandler = (page) => {
        dataEntryErrorCloseHandler();
        const state = PreviousButtonClickHandler(page, dataEntryState);
        setDataEntryState(state);
    }

    const formSaveHandler = (moveToNextItem) => {
        let errorField = "";
        if (true) {
            errorField = RequiredFieldCheck(dataEntryState.fieldChanges, dataEntryState.currentPage.Required, dataEntryState.currentPage.RequiredRule, dataEntryState.currentPage.RequiredError, dataEntryState.formDef.Pages);       
        } 

        if (errorField !== "") {
            updateDataEntryErrorStatus({visible: true, message: errorField + TranslateTag("@ValMes@",props.language)});
            return;
        }

        if (! saveEnabled) { return; }
        setSaveEnabled(false);

        const state = PrepareDataFormSavingHandler(dataEntryState, props.startConfig.view);
        state.data = AddFilterMetaData(props.filters, state.data);

        if (Array.isArray(props.startConfig.allSelectedRecords) && props.startConfig.allSelectedRecords.length > 1) {
            state.data.selectedItems = props.startConfig.allSelectedRecords;
        }
        
        PostEvent(state.data, moveToNextItem === true ? eventPostSuccessNextItem : eventPostedSuccessfully, errorWhenSavingData, state );       
        dataEntryErrorCloseHandler();       
    }

    const fieldContentsChangeHandler = (id, value, extraInfo) => {
        let state = {...dataEntryState};
 
        if (id === "multiplechanges") {
            for (const item of value) {
                state = FieldContentsChangeHandler(item.key,item.value,extraInfo, props.lists, state);
            }
        } else {
            state = FieldContentsChangeHandler(id,value,extraInfo, props.lists, dataEntryState);
        }

        PopulateFieldsWithNewContents(state.formDef.Pages, state.fieldChanges);
        
        let viewDataToUse = undefined; 

        if(id.toLowerCase() === "specimentypeid"){                  
            if(state.formDef.DefaultView !== undefined && state.formDef.DefaultView !== "") 
            {
                props.views.forEach(view => {
                    if(view.Name === state.formDef.DefaultView)
                        {
                        viewDataToUse = view;
                        }
                    });
            } else 
              {
                viewDataToUse = props.startConfig.viewData;
              }
        }
        PopulateCraftedWithNewContents(state.formDef, state.currentPage.Name, value, viewDataToUse);

        if (props.startConfig.changeHandler !== undefined && Array.isArray(state.fieldChanges))  {
            props.startConfig.changeHandler(state.fieldChanges[0]);
        }

        setDataEntryState(state);
    }

    const dynamicListsRetrieved = (data, extraInfo) => {
        IncludeDynamicListsInForm(extraInfo, data);
        if (dataEntryState !== undefined) {
            extraInfo.rootElements = dataEntryState.rootElements;
        }
        setDataEntryState(extraInfo);
    }

    const dataEntryErrorCloseHandler = () => {
        updateDataEntryErrorStatus({visible: false, message: ""});
    }

    const errorWhenSavingData = (response) => {
        const errorMessage = response.data !== undefined ? response.data : response;
        updateDataEntryErrorStatus({visible: true, message: errorMessage});
        setSaveEnabled(true);
    }

    const eventPostedSuccessfully = (id, extraInfo) => {
        if (refreshConfig) {
            GetWithNoParams('/config/get',configRetrievedSuccessfully, errorWhenSavingData);
        } else {
            if (finishAction === "update" || finishAction === "refresh" || finishAction === "refreshfilter" || finishAction === "updatefromform" || finishAction === "embeddedrefresh") {
                props.startConfig.refresh(finishAction, dataEntryState.id, extraInfo.data);
            }
            if (props.startConfig != undefined && props.startConfig.onSave != undefined) {
                props.startConfig.onSave();
            }
            closeFormHandler();
        }
    }

    const configRetrievedSuccessfully = (configData) => {
        props.updateConfig(configData);
        if (finishAction === "update" || finishAction === "refresh") {
            props.startConfig.refresh(finishAction, dataEntryState.id);
        }
        closeFormHandler();
    }

    const eventPostSuccessNextItem = () => {
        if (finishAction === "update" || finishAction === "refresh") {
            props.startConfig.refresh(finishAction, dataEntryState.id);
        }
        props.startConfig.moveToNextItem(props.startConfig.button, dataEntryState.id);
        setSaveEnabled(true);
    }

    const closeFormHandler = () => {
        setFormOpen(false);
        resetFullScreen(false);

        if (props.startConfig.containerVisibility !== undefined) {
            props.startConfig.containerVisibility(true);
        }

        setSaveEnabled(true);
        dataEntryErrorCloseHandler();

        if (props.startConfig.button.onFinish === "alwaysrefresh") {
            props.refresh("embeddedrefresh");
        }
    }

    const resetForm = () => {
        setFormOpen(false);
        resetFullScreen(false);
        setSaveEnabled(true);
        dataEntryErrorCloseHandler();
    }

    const fullScreenClickHandler = () => {
        if (displayModeSwitchable) {
            const isFullScreen = props.fullScreen === undefined ? fullScreen : props.fullScreen;
            const fullScreenValue = !isFullScreen;
            props.startConfig.containerVisibility(! fullScreenValue);
            resetFullScreen(fullScreenValue);
        }
    }

    const resetFullScreen = (value) => {
        setFullScreen(value);
        if (props.fullScreenClick !== undefined) {
            props.fullScreenClick(value);
        }
    }

    const focusOutHandler = (id, value) => {
        if (value !== undefined) {
            const defaultValues = SetDynamicDefaultValues(dataEntryState.formDef.Pages, id, value);
            if (defaultValues.length > 0) {
                for (const defValue of defaultValues) {
                    fieldContentsChangeHandler(defValue.id, defValue.value);
                }
            }
        }
    }

    let dataEntryPanel = (null);
    if (formOpen) {

        const isFullScreen = props.fullScreen === undefined ? fullScreen : props.fullScreen;

        if (props.startConfig.containerVisibility !== undefined) {
            props.startConfig.containerVisibility(! isFullScreen);
        }

        const pageToDisplay = AdjustPageToHandleMultiPageView(dataEntryState.currentPage, dataEntryState.formDef.Groups, isFullScreen);
        dataEntryPanel = (<SinglePagePanel
            id={dataEntryState.id}
            visible={true}
            currentPage={pageToDisplay}
            close={closeFormHandler}
            save={formSaveHandler}
            next={nextButtonClickHandler}
            previous={previousButtonClickHandler}
            config={dataEntryState.formDef}
            fullScreen={isFullScreen}
            displayModeSwitchable={displayModeSwitchable}
            fullScreenClick={fullScreenClickHandler}
            fieldFocusOut={focusOutHandler}
            changeHandler={fieldContentsChangeHandler}
            errorCloseHandler={dataEntryErrorCloseHandler}
            error={dataEntryErrorStatus}
            language={props.language}
            refresh={props.refresh}
            recordType={dataEntryState.formDef.RecordView}
            saveEnabled={saveEnabled}
            startConfig={props.startConfig}
            records={props.startConfig.records}
            showNextButton={props.showNextButton}
            state={dataEntryState}
            reportConfiguration={props.reportConfiguration}
            >
        </SinglePagePanel>);
    }

    return (
        <React.Fragment>
            {dataEntryPanel}
        </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        uievents: state.config.uievents,
        forms: state.config.forms,
        pages: state.config.pages,
        views: state.config.views,
        lists: state.config.lists,
        language: state.config.language,
        preferences: state.config.preferences
    };
}


export default connect(mapStateToProps)(FormHandler)